import { setup as setupHttpApi } from '@cian/http-api/browser';
import { setup as setupTelemetry } from '@cian/telemetry/browser';

export function setupDependencies(): void {
  setupTelemetry();
  setupHttpApi({});
}
